interface CloseNavigationTask {
    id: string
    workspaceId: string
    closed?: boolean
}

export type TaskCloseNavigationTarget = { type: "task"; taskId: string; workspaceId: string } | { type: "taskCreate"; workspaceId: string }

export function getNavigationTargetAfterTaskClose(sortedTasks: readonly CloseNavigationTask[], closedTaskId: string): TaskCloseNavigationTarget | null {
    const openTasks = sortedTasks.filter((task) => !task.closed)
    const closedTaskIndex = openTasks.findIndex((task) => task.id === closedTaskId)
    if (closedTaskIndex === -1) return null

    const nextTask = openTasks[closedTaskIndex + 1] ?? openTasks[closedTaskIndex - 1]
    return nextTask
        ? { type: "task", workspaceId: nextTask.workspaceId, taskId: nextTask.id }
        : { type: "taskCreate", workspaceId: openTasks[closedTaskIndex].workspaceId }
}
